import { render, staticRenderFns } from "./ShiftBox.vue?vue&type=template&id=562b4b75&"
import script from "./ShiftBox.vue?vue&type=script&lang=js&"
export * from "./ShiftBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports